import React, { useMemo } from 'react'
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'

import './index.scss'

import { BreadcrumbProps } from './types/Breadcrumb.types'
import LazySection from '../../react-only-components/LazySection'
import { anchorWithId } from '../../helpers/anchorWithId.helper'

const Breadcrumb = (props: BreadcrumbProps) => {
  const _className = useMemo(
    () =>
      `breadcrumb ${
        props.params?.Position?.length > 0
          ? `breadcrumb--${props.params?.Position} breadcrumb--${props?.params?.Color ?? ''}`
          : ''
      }`,
    []
  )

  return (
    <LazySection height={100} id={(props?.rendering?.uid as string) || ''}>
      {props?.fields && (
        <nav aria-label="Breadcrumb" className={_className}>
          <ul className="breadcrumb-list">
            {props.fields.BreadCrumbDetailList.map((item, i) => (
              <li
                key={i}
                className={
                  (item.hideinBreadCrumb === true
                    ? 'breadcrumb-list-item breadcrumbHide'
                    : 'breadcrumb-list-item')
                    +
                    (i!=0 && (i!=(props.fields?.BreadCrumbDetailList?.length ?? 0) - 1) && (i!= (props.fields?.BreadCrumbDetailList?.length ?? 0) - 2) ?" hide-mobile":"")
                }
              >
                <span className="abbreviation">{i==1 && (props.fields?.BreadCrumbDetailList?.length ?? 0) >3?"...":""}</span>
                <a
                  href={anchorWithId(item?.LinkUrl ?? '', item?.anchor)}
                  className={
                    (item.disableNavigation === false &&
                    (i !== (props.fields?.BreadCrumbDetailList?.length ?? 0) - 1)
                      ? 'breadcrumb-list-item-link'
                      : 'breadcrumb-list-item-link no-link') + 
                      (i!=0 && i!=(props.fields?.BreadCrumbDetailList?.length ?? 0) - 1 && i!=(props.fields?.BreadCrumbDetailList?.length ?? 0) - 2 ?" hide-mobile":"")
                  }
                >
                  {item.Title}
                </a>
                <span className={"arrow right"+ 
                      (i!=0 && i!=(props.fields?.BreadCrumbDetailList?.length ?? 0) - 2 && i!=(props.fields?.BreadCrumbDetailList?.length ?? 0) - 3?" hide-mobile":"")}></span>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </LazySection>
  )
}

export default withSitecoreContext()(Breadcrumb)
